import { ApiClient } from '@webapp/core/services/ApiClient'
import { RequestableCategoryRepository } from './RequestableCategoryRepository'

export const requestableCategoryRepository = new RequestableCategoryRepository({
  httpClient: ApiClient,
})

export { RequestableCategoryRepository }
